function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5771 0L4.43125 4.03357H1.98321C0.893479 4.03357 0 4.92705 0 6.01679V9.98322C0 11.073 0.893479 11.9664 1.98321 11.9664H4.43125L10.5771 16V0ZM9.255 2.44803V13.552L5.28857 10.949V5.051L9.255 2.44803ZM12.8651 4.72563L11.9251 5.65526L14.2698 8L11.9251 10.3447L12.8651 11.2795L15.2046 8.9348L17.5442 11.2795L18.4842 10.3447L16.1394 8L18.4842 5.65526L17.5442 4.72563L15.2046 7.0652L12.8651 4.72563ZM1.98321 5.35571H3.96643V10.6443H1.98321C1.61136 10.6443 1.32214 10.3551 1.32214 9.98322V6.01679C1.32214 5.64493 1.61136 5.35571 1.98321 5.35571Z",
  fill: "#23335B"
});

var SvgMute = function SvgMute(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMute, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mute.717b1185.svg";
export { ForwardRef as ReactComponent };